import script from "./BillingAdminTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BillingAdminTable.vue?vue&type=script&lang=ts&setup=true"

import "./BillingAdminTable.vue?vue&type=style&index=0&id=386aa22f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-386aa22f"]])

export default __exports__